export default __webpack_public_path__ + "static/media/img_other9.5ef8d67e.webp";